export class FetchError extends Error {
  override name = "FetchError";

  constructor(cause: unknown) {
    super(
      cause instanceof Error
        ? cause.message
        : "Request failed before receiving response",
      { cause },
    );
  }
}
